import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from './Reveal';
function HouseIllustration() {
  return <svg viewBox="0 0 260 220" fill="none" className="h-auto w-full max-w-sm" role="img" aria-label="Ilustración minimalista de una casa" data-id="element-32" data-mp="1w61mu2dmq6sx">
      <motion.path d="M20 108 130 22l110 86" stroke="#F58220" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" initial={{
      pathLength: 0
    }} whileInView={{
      pathLength: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 1.2,
      ease: 'easeInOut'
    }} data-id="element-33" data-mp="25vcudkkvb3ep" />
      <motion.path d="M48 96v100h164V96" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" initial={{
      pathLength: 0
    }} whileInView={{
      pathLength: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 1.2,
      delay: 0.4,
      ease: 'easeInOut'
    }} data-id="element-34" data-mp="2jv43b6wj1tlu" />
      <motion.path d="M108 196v-54h44v54M84 122h20M156 122h20" stroke="#FFFFFF" strokeOpacity="0.6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" initial={{
      pathLength: 0
    }} whileInView={{
      pathLength: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 1,
      delay: 0.9,
      ease: 'easeInOut'
    }} data-id="element-35" data-mp="tvypegyw6368" />
      <motion.circle cx="130" cy="120" r="6" fill="#F58220" initial={{
      scale: 0
    }} whileInView={{
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 1.6
    }} data-id="element-36" data-mp="1cv2u5djehas3" />
    </svg>;
}
export function Commitment() {
  return <section className="bg-ink py-24 sm:py-32 lg:py-40" data-id="element-37" data-mp="yvjyvlbottx7">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20" data-id="element-38" data-mp="yv1x6969anhw">
        <Reveal data-id="element-39" data-mp="3oiizn40kn98z">
          <span className="inline-flex items-center gap-2 text-xs sm:text-sm font-medium uppercase tracking-[0.18em] text-brand" data-id="element-40" data-mp="3jliucvbjqaix">
            <span className="h-px w-6 bg-brand" aria-hidden="true" data-id="element-41" data-mp="3l2g536t8ua20" />
            Nuestro compromiso
          </span>
          <h2 className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.05] tracking-tight text-white" data-id="element-42" data-mp="3q0hojsul0be0">
            Nuestro compromiso es tu tranquilidad.
          </h2>
          <p className="mt-7 max-w-xl text-base sm:text-lg leading-relaxed text-white/70" data-id="element-43" data-mp="3h0bekgy3dtjl">
            Cada cliente recibe asesoramiento personalizado y productos seleccionados uno por uno
            para brindar confort, funcionalidad y confianza. Si algo necesita atención después de la
            entrega, seguimos del otro lado.
          </p>
        </Reveal>

        <Reveal delay={0.2} className="flex justify-center lg:justify-end" data-id="element-44" data-mp="2xd3ovmzi11q7">
          <HouseIllustration data-id="element-45" data-mp="2xb10f7dzvgnl" />
        </Reveal>
      </div>
    </section>;
}